<template>
  <a-modal width="40%" :title="$t('supervise.personalConfig')" v-model="visable" centered @ok="handleOk" @cancel="handleCancel" destroyOnClose :confirmLoading="okLoading">
    <a-card>
        <ul>
          <li>
            <span>{{ $t('global.dwpl') }}:</span> 
            <div class="lists">
                <template v-for="(item, index) in locateCustomLocate">
                  <div :key="index" class="list">
                    <a-time-picker size="small"
                    v-model="item.startTime" :placeholder="$t('supervise.selecteTimeTip')"
                    format="HH:mm" />
                    <span class="span">~</span>
                    <a-time-picker size="small"
                    v-model="item.endTime" :placeholder="$t('supervise.selecteTimeTip')"
                    format="HH:mm" />
                    <span class="span">/</span>
                    <a-select size="small" style="width: 120px;" :defaultValue="item.intervalTime" v-model="item.intervalTime">
                      <template v-for="(item, index) in freqOptions">
                        <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                      </template>
                    </a-select>
                      <a-button class="deleteBtn"  @click="deleteTime(index, 'locate')" size="small">
                        <zx-icon type="icon-shanchu1"></zx-icon>
                        {{$t('global.delete')}}
                      </a-button>
                  </div>
                </template>
                <div v-if="locateCustomLocate.length < 4" class="add">
                  <a-button @click="addTime('locate')" size="small" type="primary">
                    <zx-icon type="icon-jia1"></zx-icon>
                    {{$t('supervise.addTimeOption')}}
                  </a-button>
                </div>
              </div>
          </li>
          <br> 
          <li>
            <span>{{ $t('global.healthFreq') }}:</span> 
              <div class="lists">
                <template v-for="(item, index) in healthCustomLocate">
                  <div :key="index" class="list">
                    <a-time-picker size="small"
                    v-model="item.startTime" :placeholder="$t('supervise.selecteTimeTip')"
                    format="HH:mm" />
                    <span class="span">~</span>
                    <a-time-picker size="small"
                    v-model="item.endTime" :placeholder="$t('supervise.selecteTimeTip')"
                    format="HH:mm" />
                    <span class="span">/</span>
                    <a-select size="small" style="width: 120px;" :defaultValue="item.intervalTime" v-model="item.intervalTime">
                      <template v-for="(item, index) in freqOptions">
                        <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                      </template>
                    </a-select>
                      <a-button class="deleteBtn"  @click="deleteTime(index, 'health')" size="small">
                        <zx-icon type="icon-shanchu1"></zx-icon>
                        {{$t('global.delete')}}
                      </a-button> 
                  </div>
                </template>
                <div v-if="healthCustomLocate.length < 4" class="add">
                  <a-button @click="addTime('health')" size="small" type="primary">
                    <zx-icon type="icon-jia1"></zx-icon>
                    {{$t('supervise.addTimeOption')}}
                  </a-button>
                </div>
              </div>
          </li>
          <br> 
          <li>
            <span>{{ $t('global.gpsyx') }}:</span> 
            <a-switch style= "  margin-left: 10px;"  @change="onGpsChange" v-model="enableLocateGps" checked-children="开启" un-checked-children="关闭"/>

          </li>
          <br> 
          <li>
            <span>{{ $t('global.enableSos') }}:</span> 
            <a-switch style= "margin-left: 10px;"  @change="onSosChange" v-model="enableSos" checked-children="开启" un-checked-children="关闭"/>

          </li>
        </ul>
    </a-card>
  </a-modal>
</template>
<script>
  import config from '../../config/'
  export default {
    data() {
      return {
        locateCustomLocate: [],
        healthCustomLocate: [],
        enableLocateGps:false,
        // 确定按钮加载状态
        okLoading: false,
        enableSos:false,
        // 用户配置属性
        locateFreq: 600,    
        locateFreqTemp: null,    
        locateFreqChange:false,
        enableLocateGpsTemp:null,
        enableLocateGpsChange:false,
        personId: '',
        visable: false,
        initData: '',
        groupConfig: '',
        personalConfig: '',  
        addTimeFlag:true,
      }
    },
    computed: {
      freqOptions () {
        let freq = []
        for(let i=1;i<60;i++){
          freq.push({"key":i*60,"label":i + this.$t('global.minute')},)
        }
        for(let i=1;i<=24;i++){
          freq.push({"key":i*60*60,"label":i + this.$t('global.hour')},)
        }
        return freq
      },
      
    },
    methods: {
      onGpsChange(checked) {
        console.log(`enableGps ${checked}`);
        this.enableLocateGps = checked
        // this.enableLocateGpsChange = checked != this.enableLocateGpsTemp
        // console.log(`enableLocateGpsChange ${this.enableLocateGpsChange}`);
      }, 
      onSosChange(checked) {
        console.log(`enableSos ${checked}`);
        this.enableSos = checked
      },
      handleChange(value) {
        console.log(`selected ${value}`);
        // this.locateFreqChange = value != this.locateFreqTemp
        // console.log(`locateFreqChange ${this.locateFreqChange}`);
      },
      // 修改个人配置参数
      modifiedPersonalConfig() {
        this.okLoading = true
        let newConfig = {
          // locateFreq:this.locateFreq,
          // locateFreqChange:this.locateFreqChange,
          enableLocateGps:this.enableLocateGps,
          enableSos:this.enableSos,
          // enableLocateGpsChange:this.enableLocateGpsChange,
          id: this.personId,
          oui:'OF',
          locateCustomLocate:this.locateCustomLocate ? this.locateCustomLocate.map(item => {
            return {
              ...item,
              startTime: item.startTime.unix() - this.$moment().startOf('day').unix(),
                  endTime: item.endTime.unix() - this.$moment().startOf('day').unix(),
                  intervalTime: item.intervalTime
            }
          }) : null,
          healthCustomLocate:this.healthCustomLocate ? this.healthCustomLocate.map(item => {
            return {
              ...item,
              startTime: item.startTime.unix() - this.$moment().startOf('day').unix(),
                  endTime: item.endTime.unix() - this.$moment().startOf('day').unix(),
                  intervalTime: item.intervalTime
            }
          }) : null,
        }
        console.log(newConfig);
        
        // if(!this.locateFreqChange && !this.enableLocateGpsChange){
        //   this.okLoading = false
        //   this.$notification.error({
        //       message: '配置未发生改变'
        //     })
        // }else{
          this.$http.put(config.api.put_personnal_config, newConfig).then((res) => {
            this.okLoading = false
            if (res.code === 0) {
              this.$notification.success({
                message: this.$t('global.commitSuccess')
              })
              this.visable = false
            } else {
              this.$notification.error({
                message: `${res.desc}`
              })
            }
          })
        // }
       
      },
      handleOk() {
        // console.log('ok')
        this.modifiedPersonalConfig()
      },
      handleCancel() {
        this.visable = false
        this.okLoading = false
      },
      showModal(options) {
        console.log(options)
        this.visable = true
        this.initData = options
        this.personId = options.id
        this.getPersonalConfig(this.personId) 
      },
      // 获取个人监管配置
      getPersonalConfig(personId) {
        return new Promise((resolve) => {
          this.$http.get(config.api.get_personnal_config + personId).then((res) => {
            console.log(res)
            let {
              code,
              desc,
              result
            } = res
            if (code === 0 && desc === 'success' && result) {
              // console.log(result) 
              this.locateFreq = result.personalConfigModel.locateFreq
              // this.locateFreqTemp = result.personalConfigModel.locateFreq
              this.enableLocateGps = result.personalConfigModel.enableLocateGps
              this.enableSos = result.personalConfigModel.enableSos
              // this.enableLocateGpsTemp = result.personalConfigModel.enableLocateGps
              this.locateCustomLocate = result.personalConfigModel.locateCustomLocate ? result.personalConfigModel.locateCustomLocate.map(item => {
                return {
                  ...item,
                  startTime: this.$moment().startOf('day').add(item.startTime, 'seconds'),
                  endTime: this.$moment().startOf('day').add(item.endTime, 'seconds'),
                  intervalTime: item.intervalTime

                }
              }) : []

              this.healthCustomLocate = result.personalConfigModel.healthCustomLocate ? result.personalConfigModel.healthCustomLocate.map(item => {
                return {
                  ...item,
                  startTime: this.$moment().startOf('day').add(item.startTime, 'seconds'),
                  endTime: this.$moment().startOf('day').add(item.endTime, 'seconds'),
                  intervalTime: item.intervalTime

                }
              }) : []
            }
          })
        })
      },
       
      addTime(type) {
        if(type == 'locate'){
          this.locateCustomLocate.push({
            startTime: this.$moment().startOf('day'),
            endTime: this.$moment(),
            intervalTime: 1800
          })
        }else{
          this.healthCustomLocate.push({
            startTime: this.$moment().startOf('day'),
            endTime: this.$moment(),
            intervalTime: 1800
          })
        }
      },
      deleteTime(index, type) {
        if(type == 'locate'){
          this.locateCustomLocate.splice(index, 1)
        }else{
          this.healthCustomLocate.splice(index, 1)
        }
      },
    }
  }
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
ul{
  li{
    span{
      font-size: 16px;
      font-weight: bold;
    }
  }
}
.lists {
  .list {
    margin: 10px 0 10px 0;
    display: flex;
    .span {
      margin: 0 10px;
    }
    .deleteBtn {
      margin: 0 10px;
      color: rgb(209, 21, 21);
    }
  }
}
</style>
